import styled from 'styled-components';

import { styledLayout, styledReset, styledTypography } from '@pkg/primitives';

export const CollapsedTitle = styled.button.attrs({ type: 'button' })`
    ${styledReset.button}
    ${styledLayout.fullWidthFix}

    // TODO: Add focus ring

    background-color: transparent;
    border-radius: 6px;
    transition: background-color ${({ theme }) => theme.transitions.speeds.fast}s
        ${({ theme }) => theme.transitions.easesCss.cubic};

    &:hover {
        background-color: ${({ theme }) => theme.shades.white['7']};
    }

    &:active {
        background-color: ${({ theme }) => theme.shades.white['5']};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        ${styledLayout.fullHeightFix}
        display: grid;
        align-items: center;
        justify-items: center;
    }

    // TODO: Avoid this selector.
    > span {
        ${styledTypography.truncate}
        display: block;

        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            ${styledLayout.fullHeightFix}
            ${styledTypography.verticalText(true)}
        }
    }
`;
